import $ from 'jquery';
import TeaserViewTracker from '../tracking/google/360/teaser_view_tracker';
import 'utils/sliderknobs.js';
import 'utils/slidercontrols.js';
import 'utils/sliderlazyload.js';
import 'swipe';
import PubSub from "pubsub-js";

export default function BrandTeaser() {
  PubSub.subscribe('res', $.proxy(this.responsive, this));

  this.callbackFunction = function (index, element) {
    const teaserImpressionCallback = new TeaserViewTracker().getSwipeCallbackFunction();
    teaserImpressionCallback(index, element);
    const parent = $(element).closest(".js-teasertracking");
    if (parent) {
      $(parent).attr("data-current-slide", index);
      $(parent).data("current-slide", index);
    }
  };
}

BrandTeaser.prototype.removeSwipes = function () {
  $(".label-teaser .swipe").each(function () {
    if ($(this).data("Swipe")) {
      $(this).data("Swipe").kill();
    }
  });
};

BrandTeaser.prototype.responsive = function (msg, on_off) {
  if (on_off) {
    const $labelSwiper = $(".label-teaser .swipe");

    this.removeSwipes();

    switch (msg) {
      case 'res.xs':
        $labelSwiper.Swipe({pair: 2, callback: this.callbackFunction}).knobs().lazy();
        break;
      case 'res.sm':
        $labelSwiper.Swipe({pair: 3, callback: this.callbackFunction}).knobs().lazy();
        break;
      default:
        $labelSwiper.Swipe({pair: 6, continuous: false, callback: this.callbackFunction})
          .knobs({classes: []}).controls({classes: ["hidden-md", "hidden-lt-xl"]}).lazy();
    }
  }
};
